const { __ } = wp.i18n;
/**
 * Dropdown block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("GA charts", "uipress-pro"),
  moduleName: "uip-google-analytics",
  description: __("Outputs your choice of charts and options on what data to display", "uipress-pro"),
  category: __("Analytics", "uipress-pro"),
  group: "analytics",
  icon: "bar_chart",
};
